/**
 * EditCircleIcon/index.js
 * desc: inline editing icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const EditCircleIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="edit-circle icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.editCircle.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M0 10C0 4.48 4.48 0 10 0s10 4.48 10 10-4.48 10-10 10S0 15.52 0 10zm14.837-2.754a.553.553 0 000-.784l-1.3-1.3a.553.553 0 00-.783 0L11.738 6.18l2.083 2.083 1.016-1.016zM5 12.917V15h2.083l6.144-6.144-2.083-2.083L5 12.917z"/></svg>
    </IconButton>
);


export default EditCircleIcon;
